Monitoring.Views ||= {}

class AccountSettings.TaxonomiesView extends Backbone.View
  template: JST["backbone/templates/account_settings/taxonomies/taxonomies"]

  events :
    'click #new-taxonomy': 'onClickNewTaxonomy'

  initialize: (@options = {}) ->
    @taxonomies     = @options.taxonomies

  render: =>
    @listView.remove() if @listView
    @editView.remove() if @editView
    @$el.html(@template(@))
    @renderList()
    @

  renderList: =>
    @listView.remove() if @listView
    @listView = new AccountSettings.TaxonomiesListView({
      taxonomies: @taxonomies
    })
    @$el.find('.list-view-container').append(@listView.render().el)
    @listenTo(@listView, 'edit', @renderEdit)

  onClickNewTaxonomy: ->
    @renderEdit()

  renderEdit: (taxo = new Monitoring.Models.Taxonomy) ->
    @editView.remove() if @editView
    @editView = new AccountSettings.TaxonomiesEditorView({
      taxonomy: taxo
    })
    @$el.find('.edit-view-container').html(@editView.render().el)
    @listenTo(@editView, 'cancel', @render)
    @listenTo(@editView, 'afterSave', @afterSave)

  afterSave: (newTaxonomy) ->
    @taxonomies.push(newTaxonomy)
    @render()
